export class ReadReviewsClickedUseCase {
    public execute = () => {
        const reviewsSection = document.querySelector('[data-component="product-reviews"]');
        if (reviewsSection) {
            reviewsSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    };
}
